import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import { CircularProgress } from '@mui/material'
import SubjectsTable from './components/SubjectsTable'
import { H3 } from '../../../layouts/TextStyles'
import { subjectApiSlice } from '../../../features/subject/subjectSlice'
import { toast } from 'react-toastify'
import AddSubjectDialog from './components/AddSubjectDialog'
import { ui } from '../../../utils/uiTokens'

const SubjectsPage = () => {
    const { formatMessage } = useIntl()
    const {
        data: subjects = [],
        isLoading,
        isError,
        error,
    } = subjectApiSlice.useFetchAllSubjectsQuery()
    const [deleteSubject] = subjectApiSlice.useDeleteSubjectMutation()

    const handleDelete = async (id: number) => {
        await toast.promise(deleteSubject(id).unwrap(), {
            pending: 'Deleting',
            success: 'Delete successful',
            error: 'Could not delete item',
        })
    }

    useEffect(() => {
        if (error && 'status' in error && error?.status === 'FETCH_ERROR') {
            toast.error(error?.status)
        }
    }, [error])

    return (
        <Wrapper>
            <Content>
                <Header>
                    <Title>
                        <H3>{formatMessage({ id: 'subjects' })}</H3>
                    </Title>

                    <AddSubjectDialog />
                </Header>

                <SubjectsTable
                    subjectsData={subjects}
                    onDelete={handleDelete}
                />

                {isLoading && <CircularProgress />}
            </Content>
        </Wrapper>
    )
}

export default SubjectsPage

const Wrapper = styled.div`
    margin: 10px;
    border-radius: 16px;
`

const Title = styled.div`
    margin-bottom: 20px;
    text-align: left;
    display: flex;
    align-items: center;
`

const Content = styled.div`
    background-color: ${ui.card};
    border-radius: 16px;
    padding: 20px;
    min-height: 80vh;
`

const Header = styled.header`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
`
